import { InjectionToken } from "@angular/core";

export const TABLE_VALUE_FORMAT = new InjectionToken<string>("Digits format for values");
